"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serialize = exports.parse = exports.parseSingle = void 0;
__exportStar(require("./type"), exports);
const parseSingleAnimationShorthand_1 = require("./parseSingleAnimationShorthand");
exports.parseSingle = parseSingleAnimationShorthand_1.parseSingleAnimationShorthand;
const parseAnimationShorthand_1 = require("./parseAnimationShorthand");
const parse = (input) => [...(0, parseAnimationShorthand_1.parseAnimationShorthand)(input)];
exports.parse = parse;
const serializeAnimation_1 = require("./serializeAnimation");
exports.serialize = serializeAnimation_1.serializeAnimation;
